define('pwa/view/controller/dashboard/DashboardView',['require','lib/view/LayoutView','model/ClientTimeZoneModel','model/CompanyModel','pwa/view/controller/dashboard/DashboardCompanyInfoView','view/controller/booking/result/BookingResultLayout','pwa/view/controller/dashboard/suggested-booking/DashboardSuggestedBookingLayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ClientTimeZoneModel = require('model/ClientTimeZoneModel');
    var CompanyModel = require('model/CompanyModel');

    var DashboardCompanyInfoView = require('pwa/view/controller/dashboard/DashboardCompanyInfoView');
    var BookingResultLayout = require('view/controller/booking/result/BookingResultLayout');
    var DashboardSuggestedBookingLayoutView = require('pwa/view/controller/dashboard/suggested-booking/DashboardSuggestedBookingLayoutView');

    /**
     * @class DashboardView
     */
    return LayoutView.extend({

        template: '#dashboard_page_view',

        regions: {
            'companyInfo': '#sb_dashboard_company_info',
            'suggestedBookingListLayout': '#sb_dashboard_suggested_booking_layout',
            'bookingListLayout': '#sb_dashboard_booking_layout'
        },

        _clientTimeZone: null,

        initialize: function () {
            LayoutView.prototype.initialize.apply(this);

            this._clientTimeZone = new ClientTimeZoneModel();
        },

        onShow: function () {
            this.showChildView('companyInfo', new DashboardCompanyInfoView({
                model: this._getModel(),
            }));

            this.showChildView('suggestedBookingListLayout', new DashboardSuggestedBookingLayoutView({
                data: {
                    limit: 2,
                },
                clientModel: this.getOption('clientModel')
            }));

            this.showChildView('bookingListLayout', new BookingResultLayout({
                data: {
                    type: 'upcoming',
                },
                clientTimeZone: this._clientTimeZone,
                clientModel: this.getOption('clientModel')
            }));
        },

        onDomRefresh: function () {
            this.onShowPage();
        },

        onShowPage: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'dashboard'
            });
        },

        /**
         * instantiates and returns CompanyModel instance
         *
         * @reurn CompanyModel
         */
        _getModel: function () {
            if (!this._model) {
                this._model = new CompanyModel();
                this._model.fetch();
            }
            return this._model;
        }

    });

});
